<template>
  <b-container class="py-3">
    <b-row>
      <b-col md="8">
        <h2 class="exam__detail__name">{{ exam.name }}</h2>

        <b-row>
          <b-col>
            <div class="exam__detail__block exam__detail__block--column p-4">
              <div class="exam__detail__time">
                Tổng thời lượng: <span>{{ exam.time }} phút</span>
              </div>

              <ul class="exam__detail__timeline timeline">
                <li class="timeline__item">
                  <span>Bắt đầu</span>
                </li>
                <template v-if="exam.rank">
                  <li v-for="skill in exam.rank.skills" :key="skill.id" class="timeline__item">
                    <strong>{{ skill.name }}</strong>
                    <small>{{ skill.time }} phút</small>
                  </li>
                </template>
                <li class="timeline__item">
                  <span>Kết thúc</span>
                </li>
              </ul>
            </div>
          </b-col>
          <b-col md="6">
            <div class="exam__detail__block exam__detail__block--column p-4">
              <div class="exam__detail__status">
                <img src="@/assets/images/ic_exam_detail.png" />

                <template v-if="!exam.purchase">
                  <b-link v-if="exam.price" class="btn__normal" :to="{
                    name: 'exam-purchase',
                    params: { id: exam.id, slug: exam.slug }
                  }">Mua đề thi</b-link>
                  <b-link v-else class="btn__normal" :to="{
                    name: 'exam-purchase-confirm',
                    params: { id: exam.id, slug: exam.slug }
                  }">Làm đề ngay</b-link>
                </template>

                <b-link v-if="exam.purchase == 1" class="btn__normal">Chờ xét duyệt</b-link>

                <b-link v-if="exam.purchase == 9" class="btn__normal" :to="{
                  name: 'exam-response',
                  params: { id: exam.id, slug: exam.slug }
                }">Vào thi ngay</b-link>

                <!-- <p class="text-left pt-3"><fa-icon icon="circle" class="text-danger" /> Tham gia thi thử tại cổng thi để
                  được mở
                  khóa toàn bộ đề HSK: <b-link :to="{ name: 'thi-thu' }">VÀO CỔNG THI NGAY</b-link></p> -->
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- BOX ADS VIP -->
         <router-link :to="{ name: 'package-list' }" class="ads-vip-box" v-if="user && user.user_packages && user.user_packages.length === 0">
            <img src="@/assets/images/pages/exam-detail/vip.gif" alt="vip" width="50px" />
            <span>Đăng ký tham gia <span class="highlight">Thành viên VIP</span> để được mở khoá toàn bộ đề thi HSK trên hệ thống</span>
         </router-link>
        <!-- BOX ADS VIP -->

        <h3 class="exam__detail__title">Thông tin đề thi</h3>

        <div class="exam__detail__content" v-html="exam.content"></div>

        <h3 class="exam__detail__title mt-3">Bảng xếp hạng</h3>

        <div class="exam__detail__block scroll_list p-4">
          <template v-if="examScore.length">
            <ul class="exam__score__list">
              <li v-for="item in examScore" :key="item.id" class="exam__score__item clearfix">
                <div class="exam__score__item__icon">
                  <span>{{ item.user.name.substring(0, 2) }}</span>
                </div>
                <div class="exam__score__item__content">
                  <b-row>
                    <b-col><strong>{{ item.user.name }}</strong></b-col>
                    <b-col v-if="exam.rank">
                      <div class="text-right">
                        {{ Math.floor(item.scores) }} /
                        {{ exam.rank.max_point }} điểm
                      </div>
                    </b-col>
                  </b-row>
                  <div class="exam__score__item__point">
                    <span v-for="skill in getSkills(item.scores_part)" :key="skill.id" :style="`width: ${getSkillScoreWidth(skill.scores)}%`">{{
                        Math.floor(skill.scores) }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </template>
          <template v-else>
            Chưa có dữ liệu
          </template>
        </div>

        <h3 class="exam__detail__title mt-3">Lịch sử làm đề thi</h3>

        <div class="exam__detail__block p-1" v-if="this.$store.state.auth.isLoggedIn">
          <div v-if="isLoading">
            <div class="text-center my-5">
              <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
              <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
              <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>

              <div>Loading...</div>
            </div>
          </div>
          <div v-else>
            <b-table striped hover outlined head-variant="light" :items="examHistory.slice(0, 10)"
              :fields="examHistoryFields" :busy="isLoadingHistory" show-empty class="mb-0">
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:empty="">
                <h6 class="text-center">Không có dữ liệu</h6>
              </template>
              <template v-slot:emptyfiltered="">
                <h6 class="text-center">Không có dữ liệu</h6>
              </template>
              <template v-slot:cell(index)="data">
                <div class="text-center">{{ data.index + 1 }}</div>
              </template>
              <template v-slot:cell(exam)="data">
                <b-link :to="{ name: 'exam-result', params: { id: data.item.id } }" class="btn__result">{{
                  data.item.status ? 'Xem kết quả' : 'Xem bài làm' }}</b-link>
              </template>
            </b-table>
          </div>
        </div>
      </b-col>
      <b-col md="4">
        <h3 class="exam__detail__title">Đề thi liên quan</h3>

        <div class="exam__detail__block exam__detail__block-recommend p-4">
          <template v-if="exam.relates">
            <div v-for="relatedExam in exam.relates" :key="relatedExam.key" class="exam__detail__related">
              <div class="exam__item">
                <div class="exam__item__header clearfix">
                  <div class="exam__item__icon">
                    <img src="@/assets/images/ic_exam_thumb.png" width="64" />
                  </div>
                  <h4 class="exam__item__name">
                    <b-link :to="{
                      name: 'exam-detail',
                      params: { id: relatedExam.id, slug: relatedExam.slug }
                    }">{{ relatedExam.name }}</b-link>
                  </h4>
                  <span class="exam__item__time"><fa-icon icon="clock" :style="{ color: '#17a2b8' }" />
                    {{ exam.time }} phút</span>
                </div>
              </div>
            </div>
          </template>
          <div v-else>Chưa có dữ liệu</div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { STORE_KEY } from "../_store/constants";

export default {
  name: "ExamDetail",
  data() {
    return {
      id: this.$route.params.id,
      slug: this.$route.params.slug,
      examHistoryFields: [
        {
          key: "index",
          label: "STT"
        },
        {
          key: "created_at",
          label: "Thời gian thi"
        },
        {
          key: "scores",
          label: "Số điểm",
          formatter: (value) => {
            return value.toLocaleString();
          }
        },
        {
          key: "status",
          label: "Trạng Thái",
          formatter: (value) => {
            return value ? "Đã chấm bài viết" : "Chờ chấm bài viết";
          },
          tdClass: (value) => {
            return value ? "text-success" : "text-warning";
          }
        },
        {
          key: "exam",
          label: "Tác vụ"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      exam: `${STORE_KEY}/exam`,
      isLoading: `${STORE_KEY}/isLoading`,
      isLoadingHistory: `${STORE_KEY}/isLoadingHistory`,
      examHistory: `${STORE_KEY}/examHistory`,
      examScore: `${STORE_KEY}/examScore`
    }),
    ...mapState('auth', ['user'])
  },
  beforeMount() {
    this.getExamInfo(this.id);
    this.getExamTopScore(this.id);
    if (this.$store.state.auth.isLoggedIn) {
      this.getExamHistory(this.id);
    }
  },
  metaInfo() {
    return {
      title: this.exam ? this.exam.name : '',
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.exam.description
        },
        { vmid: "keywords", name: "keywords", content: this.exam.meta_keyword },
        { vmid: "robots", name: "robots", content: "index, follow" },
        // OPG
        {
          property: "og:title",
          content: this.exam.name || "TRYHSK Online"
        },
        { property: "og:site_name", content: "TRYHSK Online" },
        // The list of types is available here: http://ogp.me/#types
        { property: "og:type", content: "website" },
        {
          property: "og:url",
          content: `${process.env.BASE_URL}de-thi/${this.exam.slug}-${this.exam.id}`
        },
        { property: "og:description", content: this.exam.description }
      ],
      link: [
        {
          rel: "canonical",
          href: `${process.env.BASE_URL}de-thi/${this.exam.slug}-${this.exam.id}`
        }
      ]
    };
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "getExamInfo",
      "getExamHistory",
      "getExamTopScore"
    ]),
    getSkills(value) {
      return JSON.parse(value);
    },
    getSkillScoreWidth(value) {
      if (this.exam.rank) {
        return Math.floor((value / this.exam.rank.max_point) * 100);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ads-vip-box {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #1ba3b9;
  color: #1ba3b9;
  font-weight: 500;

  .highlight {
    color: orange;
  }
}
</style>